import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";

export const GetSourceDetails = async (params: any) => {
  try {
    const response = await postCall(urlConfig.SourceDetails, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
}

export const AddSourceConfig = async (params: any) => {
  try {
    const response = await postCall(urlConfig.AddSourceConfig, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
}
